import { render } from "./EntitySelectorMultiCarreta.vue?vue&type=template&id=6573d3ee"
import script from "./EntitySelectorMultiCarreta.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorMultiCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script